export default "<p>error404 works!</p>\n"